const state = {
    idList: {
        FREE: 1,
        FREEMIUM: 2,
        PREMIUM: 3
    }
};

export default {
    namespaced: true,
    state
};
